import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { buildWebsiteUrl, WebsiteURL } from "healthex-common/websiteurls";
import { observer } from "mobx-react";
import { useEffect, useRef } from "react";
import { Trans, useTranslation } from "react-i18next";
import { i18nGetCurrentLanguage } from "../Infra/i18next";
import { makeCheckLoaded } from "../Infra/RemoteData";
import clearLogoDark from "../Media/clear-logo-dark.svg";
import clearLogoLight from "../Media/clear-logo-light.svg";
import { FlexColumn } from "./common.styles";
import { ScreenTitle } from "./DocumentRetrievalRecordsShared.styles";
import { HXMobileButton } from "./HXButton";
import { ContentContainer, LightText } from "./HXMobilePage.styles";
import { TitleHeaderView } from "./HXMobileTitleHeader";
import { FooterView } from "./PatientConsentManagerShared";
import { FooterText, FooterTextLink, PageWithFixedHeaderAndFooterContent } from "./PatientConsentManagerShared.styles";
import { PatientLandingViewModel } from "./PatientLandingViewModel";
import { spinner } from "./Spinner";
import { useViewModel } from "./useViewModel";
const checkLoaded = makeCheckLoaded(PatientLandingViewModel, "organization", "pageTitle");
export const PatientLandingView = observer((props) => {
    const { t } = useTranslation(["patients"]);
    const model = useViewModel(PatientLandingViewModel, props.container);
    const hasInitialized = useRef(false);
    const webAddress = props.container.environment.WEBSITE_BASE_URL;
    useEffect(() => {
        if (hasInitialized.current) {
            return;
        }
        hasInitialized.current = true;
        model.handleClearIAL2LoginRedirectIfNeeded();
    }, [model]);
    if (!checkLoaded(model)) {
        return spinner();
    }
    return (_jsxs(FlexColumn, { grow: true, children: [_jsx(PageWithFixedHeaderAndFooterContent, { isHeaderAndFooterFixed: false, children: _jsxs(ContentContainer, { children: [_jsx(TitleHeaderView, { showBottomBorder: false, title: undefined, showLogo: true, padding: "48px 0px 32px 0px" }), _jsxs(FlexColumn, { gap: 16, alignItems: "center", children: [_jsx(ScreenTitle, { children: model.pageTitle }), _jsx(LightText, { center: true, children: model.supportingText })] })] }) }), _jsx(FooterView, { container: props.container, showLangugePicker: true, useInMemoryLanguageForLanguagePicker: false, textElement: _jsx(FooterText, { children: _jsx(Trans, { t: t, i18nKey: "By continuing, you agree to HealthEx\u2019s<br/><terms>Terms</terms> and <privacy>Privacy Policy</privacy>.", components: {
                            terms: (_jsx(FooterTextLink, { href: buildWebsiteUrl(WebsiteURL.TERMS, webAddress, i18nGetCurrentLanguage()), target: "_blank", rel: "noopener noreferrer" })),
                            privacy: (_jsx(FooterTextLink, { href: buildWebsiteUrl(WebsiteURL.PRIVACY, webAddress, i18nGetCurrentLanguage()), target: "_blank", rel: "noopener noreferrer" })),
                            br: _jsx("br", {}),
                        } }) }), buttons: [
                    _jsx(HXMobileButton, { fullWidth: true, onClick: (e) => {
                            e.preventDefault();
                            void model.continueWithClear();
                        }, loading: model.isLoggingIn, startIcon: model.smartAuthErrorReason ? undefined : (_jsx("img", { src: model.isClearDefault ? clearLogoLight : clearLogoDark, width: 24, height: 24 })), children: model.clearButtonLabel }, "continue-with-clear"),
                    _jsx(HXMobileButton, { fullWidth: true, text: true, onClick: () => model.loginAsOrganizationAdmin(), children: t("Log in as an organization user") }, "login-as-organization-admin"),
                ] })] }));
});
